import React from 'react'
import Certificate_Banner from './certificate-banner/Certificate_Banner'
import About_Us from './about-us/About_Us'
import Choose_Your_Quiz from './choose-your-quiz/Choose_Your_Quiz'
import Industry_Standard from '../home/industry-standard/Industry_Standard'
import Terms_Conditions from './terms-conditions/Terms_Conditions'
import What_Participant_Say from './what-participant-say/What_Participant_Say'
import Leave_A_Comment from './leave-a-comment/Leave_A_Comment'

const Claim_Certificate = () => {
    return (
        <>
            <Certificate_Banner />
            <About_Us />
            <Choose_Your_Quiz />
            <Industry_Standard />
            <Terms_Conditions />
            <What_Participant_Say />
            <Leave_A_Comment />
        </>
    )
}

export default Claim_Certificate